/**
 * tm/smsState.tsx — 보낸 문자 상태 한 벌 (2026-10-29 지도사 「정상적으로 나갔는지 안 나갔는지 바로 보여 줘」 · 서버 services/smsDelivery.view)
 *  ok 받음(휴대폰에 닿음) · wait 보내는 중(통신사 결과 기다림) · fail 못 받음(결번 · 수신거부 …) · rejected 못 보냄(알리고가 안 받음)
 *  상담 결과 보내기 · 업체 「보낸 문자」가 같이 쓴다
 */
import { C, T } from './components/ui';

export type SmsState = 'ok' | 'wait' | 'fail' | 'rejected';
export const SMS_STATE: Record<SmsState, { label: string; fg: string; bg: string }> = {
  ok: { label: '받음', fg: '#047857', bg: '#ECFDF5' },
  wait: { label: '보내는 중', fg: '#6B7280', bg: '#F3F4F6' },
  fail: { label: '못 받음', fg: C.red, bg: '#FEF2F2' },
  rejected: { label: '못 보냄', fg: C.red, bg: '#FEF2F2' },
};
export function asSmsState(v: unknown): SmsState { return v === 'ok' || v === 'wait' || v === 'fail' || v === 'rejected' ? v : 'wait'; }

/** 상태 표 — 같은 폭(줄마다 나란히) · 못 받음 · 못 보냄이면 이유를 title 로 */
export function SmsStateTag({ state, note }: { state: SmsState; note?: string }) {
  const s = SMS_STATE[state];
  return <span title={note || undefined} style={{ display: 'inline-block', width: 64, textAlign: 'center', flexShrink: 0, fontSize: T.xs, fontWeight: 700, padding: '3px 0', borderRadius: 6, background: s.bg, color: s.fg, whiteSpace: 'nowrap' }}>{s.label}</span>;
}

/** 오전/오후 시각 — 10/29 오후 2:05 */
export function smsWhen(iso: string): string {
  const d = new Date(new Date(iso).getTime() + 9 * 3600 * 1000);
  if (isNaN(d.getTime())) return '';
  const h = d.getUTCHours(), mi = String(d.getUTCMinutes()).padStart(2, '0');
  return `${d.getUTCMonth() + 1}/${d.getUTCDate()} ${h < 12 ? '오전' : '오후'} ${h % 12 || 12}:${mi}`;
}
